import {
  getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { PostApiV1ThreeLetterCodeClientAdminsClientNewsletters201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 社内報作成APIを実行するカスタムフック。
 * main_image は Base64 Data URI 形式で JSON 送信する。
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostInternalNews = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsClientNewsletters201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationFetcher(threeLetterCode),
    options
  );
};
